const maintenanceButtonEquip = {
  true: 'Retornar da',
  false: 'Enviar para',
  label: 'Manutenção'
};

export default maintenanceButtonEquip;
